export const environment = {
    production: true,
    mixpanelProjectId: '71ac4487688306dc78e09f40d8018b9b',
    googleAnalyticsTrackingId: 'G-HXW25ZBCNY',
    googleMapsApiKey: 'AIzaSyAdehfQwDgv8G8J7zbAc-197bEIthWpGKs',
    recaptcha: {
        siteKey: '6LcYZroqAAAAAHS3AGlsPzDqCReZHFsc_TiJGCa1',
    },
};
